import { disableLogo } from './../components/logo';



/*
 * barba view
 */
const Team = {
  namespace: 'team',
  beforeLeave: (data) => {
    console.log('view about beforeLeave');
  },

  afterLeave: (data) => {
    console.log('view about afterLeave');
  },

  beforeEnter: (data) => {
    console.log('view about beforeEnter');
  },
  afterEnter: (data) => {
    console.log('view about afterEnter');
    disableLogo();
  }
}

export default Team;
